import CreditNoteView from './CreditNoteViewContainer';
export default CreditNoteView;
